<template>
    <v-modal title="Share your tab" @close="$emit('close')">
        <div slot="content">
            <p class="stack-m">Copy this link to send it to another user</p>
            <r-input
                :value="url"
                :autoHighlightOnFocus="true"/>
        </div>

        <template slot="actions">
            <r-button
                type="primary"
                @click="copy"
                :disabled="!isClipboardSupported"
                :data-tooltip="buttonTooltip"
                class="has-tooltip">Copy</r-button>
        </template>
    </v-modal>
</template>

<script>
    import Clipboard from '@/common/clipboard';
    import vModal from '@/components/modal/v-modal';

    export default {
        name: 'share-settings-modal',
        components: {
            vModal,
        },
        props: {
            url: {
                type: String,
                default: '',
            },
        },
        computed: {
            isClipboardSupported() {
                return Clipboard.isSupported;
            },
            buttonTooltip() {
                if (this.isClipboardSupported) {
                    return 'Click button to copy';
                }
                return 'Auto copy is not available, please copy link manually';
            },
        },
        methods: {
            async copy() {
                try {
                    await Clipboard.copy(this.url);
                    this.$toast.positive('Tab link copied to clipboard');
                    this.$emit('close');
                } catch (error) {
                    this.$toast.negative('Please copy the link manually');
                }
            },
        },
    };
</script>
